import { useEffect } from "react";
import ChatPage from "../common/ChatPage";
import Loader from "../../components/loader";
import { getProfile } from "../../utils/pip";
import AdminLayout from "../../layouts/AdminLayout";
import { useDispatch, useSelector } from "react-redux";
import { SocketBootstrap } from "../../components/chat/SocketBootstrap";
import { setActiveChat } from "../../redux/features/chat/chatSlice";
const Inbox = () => {
  const dispatch = useDispatch();
  const user = getProfile("admin");

  const { subLoading } = useSelector((state) => state.admin.auth);

  useEffect(() => {
    return () => {
      dispatch(setActiveChat(null));
    };
  }, []);

  if (subLoading) {
    return <Loader />;
  }
  return (
    <div>
      <AdminLayout>
        <SocketBootstrap role="admin" />
        <ChatPage userId={user.admin_id} role={"admin"} />
      </AdminLayout>
    </div>
  );
};

export default Inbox;